import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import colors from '../../../scss/colors';
import classes from './BaseSwipeableDrawer.module.scss';

const BaseSwipeableDrawer = ({
  open = true,
  closeHandler,
  children,
  verticalScroll = 'auto',
  isDivider = false,
  height = 'auto',
  zIndex = 9999
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={() => {}}
      onClose={closeHandler}
      sx={{
        '& .MuiModal-root-MuiDrawer-root': {
          zIndex: 1
        },
        '& .MuiPaper-root.MuiDrawer-paper': {
          backgroundColor: 'transparent',
          overflow: 'hidden',
          height,
          zIndex
        },
        zIndex: zIndex
      }}
      data-testid="swipeable-drawer"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          padding: '20px 0 24px 0',
          backgroundColor: colors.PAGE_BACKGROUND,
          borderRadius: '20px 20px 0 0',
          zIndex: 9999,
          overflowY: verticalScroll
        }}
      >
        {isDivider && <div className={classes.swiper} />}
        {children}
      </Box>
    </SwipeableDrawer>
  );
};

export default BaseSwipeableDrawer;
